module.exports = __webpack_public_path__ + "assets/2f50fe3e24361288c621431bb384d006.png";